module.exports = __webpack_public_path__ + "static/assets/cd3ae8644ba48b0fba98d322ac5903cf.png";